import { useEffect, useRef } from "react";

import { type Data, DotLottie } from "@lottiefiles/dotlottie-web";

import { cn } from "~/lib/utils";

import Typography from "./typography";

const AnimatedSticker: React.FC<{
  title?: string;
  desc?: string;
  data: { raw: Data; src?: undefined } | { src: string; raw?: undefined };
  flipH?: boolean;
  responsive?: boolean;
}> = (props) => {
  const canvasEl = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    new DotLottie({
      autoplay: true,
      loop: true,
      canvas: canvasEl.current!,
      src: props.data.src, // Dynamic source
      data: props.data.raw,
    });
  }, []);

  return (
    <div className="flex flex-col items-center gap-4 p-4 my-auto">
      <canvas
        ref={canvasEl}
        id="dotlottie-canvas"
        className={cn("backdrop-blur-xs w-56 h-56", {
          "-scale-x-100": props.flipH,
          "w-28 h-28 lg:w-56 lg:h-56": props.responsive,
        })}
      />

      {props.desc && props.title && (
        <div className="text-center flex flex-col gap-2 max-w-80">
          {props.title && <Typography variant="h1">{props.title}</Typography>}
          {props.desc && <Typography variant="p">{props.desc}</Typography>}
        </div>
      )}
    </div>
  );
};

export default AnimatedSticker;
